import { Check, Loader2, Sparkles } from "lucide-react";
import { Button } from "./ui/button";

export const MAX_RENDERS = 3;
const keyOf = (dataUrl) => dataUrl.slice(-48); // tail of the base64 payload is unique per image

// Thumbnail picker for the up-to-3 render options, with skeletons while more are generating.
export const RenderOptions = ({ renders, selected, busy, varying, onSelect, onVariations }) => {
  const missing = MAX_RENDERS - renders.length;
  return (
    <div data-testid="render-options" className="mt-5 flex items-center gap-3 flex-wrap">
      {renders.map((r, i) => (
        <button
          key={keyOf(r)}
          data-testid={`render-option-${i}`}
          aria-pressed={i === selected}
          onClick={() => i !== selected && onSelect(i)}
          disabled={!!busy}
          className={`relative h-20 w-20 sm:h-24 sm:w-24 rounded-2xl overflow-hidden border-2 transition-transform hover:scale-[1.03] ${
            i === selected ? "border-primary ring-2 ring-primary/40" : "border-border"
          }`}
        >
          <img src={r} alt={`option ${i + 1}`} className="h-full w-full object-cover" />
          {i === selected && (
            <span className="absolute bottom-1 right-1 rounded-full bg-primary text-primary-foreground p-1">
              <Check className="h-3 w-3" />
            </span>
          )}
        </button>
      ))}
      {varying &&
        Array.from({ length: missing }, (_, i) => renders.length + i).map((slot) => (
          <div key={`slot-${slot}`} data-testid="render-option-skeleton" className="h-20 w-20 sm:h-24 sm:w-24 rounded-2xl border-2 border-dashed border-border grid place-items-center animate-pulse">
            <Loader2 className="h-5 w-5 animate-spin text-accent" />
          </div>
        ))}
      {missing > 0 && !varying && (
        <Button data-testid="more-variations-btn" variant="secondary" className="h-20 sm:h-24 rounded-2xl gap-2 px-5 font-semibold" onClick={onVariations} disabled={!!busy}>
          <Sparkles className="h-4 w-4 text-accent" /> Show {missing} more option{missing > 1 ? "s" : ""}
        </Button>
      )}
    </div>
  );
};
